export default __webpack_public_path__ + "static/customers_table-5f265dcf03c93bef12419a7ac4231892.png";